

































































































































































import {Component, Mixins, Prop} from 'vue-property-decorator'
import NetworkTag from '@/components/NetworkTag.vue'
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import {Swiper as SwiperClass} from 'swiper'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'

@Component({
  components: {
    NetworkTag,
    Swiper,
    SwiperSlide,
  },
})
export default class OrbitCardCarousel extends Mixins(MixinScreenSize) {
  @Prop({type: OrbitProjectCollection, required: true})
  orbitProjectCollection!: OrbitProjectCollection

  isBeginning = true
  isEnd = true

  swiper!: SwiperClass

  get swiperOption() {
    return {
      centerInsufficientSlides: true,
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 24,
      pagination: {
        el: '.stats-swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
      },
    }
  }

  updateEvent() {
    this.isBeginning = this.swiper.isBeginning
    this.isEnd = this.swiper.isEnd
  }

  updateSwiper() {
    if (this.swiper) {
      this.swiper.update()
    }
  }

  async initSwiper(swiper: SwiperClass) {
    this.swiper = swiper
    this.updateEvent()
    this.updateSwiper()
  }

  prevSlide() {
    if (!this.swiper.isBeginning) {
      this.swiper.slidePrev()
    }
    this.updateEvent()
  }

  nextSlide() {
    if (!this.swiper.isEnd) {
      this.swiper.slideNext()
    }
    this.updateEvent()
  }
}
